




























































import { defineComponent, PropType, ref, computed, useFetch } from '@nuxtjs/composition-api';
import ProductReviewCard from '~/components/pages/Product/ProductReviewCard.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppLoader from '~/components/partials/App/AppLoader.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import AppReviewStars from '~/components/partials/App/AppReviewStars.vue';
import { useStore } from '~/composables/useStore';
import { SORT_PARAMETERS } from '~/constants';
import { filterReviewRating } from '~/utils/modules/products';
import { url } from '~/utils/url';
import { CommentData } from '~/types/modules/comment';
import { ProductReviewSetting } from '~/types/modules/product';

export default defineComponent({
  components: {
    AppIcon,
    AppLink,
    AppLoader,
    AppRectButton,
    ProductReviewCard,
    AppReviewStars,
  },
  props: {
    productCode: {
      type: String,
      required: true,
    },
    reviewSettings: {
      type: Object as PropType<ProductReviewSetting>,
      default: null,
    },
    comments: {
      type: Array as PropType<CommentData[]>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const hasUserPostedComment = ref(false);
    const isLoading = ref(true);
    const hasComments = computed(() => props.comments.length > 0);
    const commentFormPath = computed(() => url('COMMENT_FORM_NEW', { code: props.productCode }));
    const headerHeightSum = computed(
      () => store.state.internals.header.headerHeight + store.state.internals.header.headerMenuHeight
    );

    useFetch(async () => {
      try {
        if (!props.reviewSettings.review_group_id || !store.state.auth.authenticated) {
          return;
        }

        // 投稿済みか確認(ロジックは/comment/listを流用)
        const userReviews = await store.dispatch('modules/reviews/fetchCommentsByUserId', {
          query: {
            limit: 10,
            page: 1,
            sort: SORT_PARAMETERS.CREATED_AT,
            review_group_id: props.reviewSettings.review_group_id,
          },
        });
        // 掲載状態・ステータスにかかわらず投稿数が0 または 投稿したレビューが全て非公開の承認されたレビューの場合、投稿可能
        // ↓はその逆のboolean、わかりづらかったら修正
        const approvedPrivateCommentsLength = userReviews.data.filter(
          (review) => !review.display_flag && review.status === 'approved'
        ).length;
        hasUserPostedComment.value =
          userReviews.data.length > 0 ? !!(userReviews.data.length - approvedPrivateCommentsLength) : false;
      } catch {
        // 何もしない
      } finally {
        isLoading.value = false;
      }
    });

    return {
      hasUserPostedComment,
      isLoading,
      hasComments,
      commentFormPath,
      filterReviewRating,
      headerHeightSum,
      url,
    };
  },
});
